import { Table, TableProps, Tag } from 'antd';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthContext } from '../../../../../../../context/auth-context';
import { ProgramDto } from '../../../../../../../types/dto/event.dto';
import { ProgramLevel } from '../../../../../../../types/enum/program-level';
import { ProgramMode } from '../../../../../../../types/enum/program-mode';
import { getTagClassName } from '../../../../../../../utils/get-tag-class-name';

interface Props {
  programs: ProgramDto[];
}

const SubjectPrograms = ({ programs }: Props) => {
  const { language } = useContext(AuthContext);
  const { t } = useTranslation(['user', 'programs']);

  const columns: TableProps<ProgramDto>['columns'] = [
    {
      key: 'programName',
      title: t('programs:columns.program_name'),
      dataIndex: 'programName',
      width: '50%',
      render: (name, record) => (
        <span>
          {language === 'en'
            ? record.programNameEn ?? record.programName
            : record.programName}
        </span>
      ),
    },
    {
      key: 'level',
      title: t('programs:columns.level'),
      dataIndex: 'level',
      width: '10%',
      align: 'center',
      render: (level) => (
        <Tag className={getTagClassName(level as ProgramLevel)}>
          {t(`programs:levels.${level}`)}
        </Tag>
      ),
    },
    {
      key: 'mode',
      title: t('programs:columns.mode'),
      dataIndex: 'mode',
      width: '15%',
      align: 'center',
      render: (mode) => (
        <Tag className={getTagClassName(mode as ProgramMode)}>
          {t(`programs:modes.${mode}`)}
        </Tag>
      ),
    },
    {
      key: 'location',
      title: t('programs:columns.location'),
      dataIndex: 'location',
      width: '10%',
      align: 'center',
      render: (location) => <Tag>{t(`programs:locations.${location}`)}</Tag>,
    },
  ];

  return (
    <div>
      <Table
        rowKey={(val) => val.id}
        scroll={{ x: 800 }}
        size='small'
        dataSource={programs}
        pagination={{ hideOnSinglePage: true }}
        columns={columns}
      />
    </div>
  );
};

export default SubjectPrograms;
